<template>
  <div class="pvDrawLine">
    <el-dialog :title="dialogTitle" custom-class="pvDetailBox" :visible.sync="isShowDetail" :fullscreen="fullscreen" :close-on-click-modal ="false"  align="center" width="80%" @close="close">
      <el-row>
        <el-col  align="center">
          <!--表格-->
          <div class="chartDiv" style=" margin-top: 3%; margin-left: auto; margin-right: auto; width: 1000px;"
             align="center" v-loading="chartLoading">
            <highstock :options='options' style="width: 100%;"></highstock>
          </div>
          <div style="margin-top: 1%;">
            <div style="display: inline-block;margin-right: 0.5%;font-size: 14px;">Sample:</div>
            <el-select v-model="ppValue" placeholder="请选择" style="width:150px;"  :disabled = "isDisabled" >
              <el-option
              v-for="item in ppOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
              </el-option>
            </el-select>  
          </div>
          <div class="block" style="margin-top: 1%;font-weight: bold;" align="center">
            <el-date-picker
              v-model="value5"
              type="datetimerange"
              :picker-options="pickerOptions"
              range-separator="to"
              start-placeholder="start time"
              end-placeholder="end time"
              align="right"
              style="width:500px;"
            >
            </el-date-picker>
          </div>
          <div style="margin-top: 1%" align="center">
            <el-button v-on:click="query" type="primary" style="background-color: #004499; border-color: #004499"
                      :disabled="queryDisabled">Draw Line Chart
            </el-button>
            <el-button v-on:click="showStatistics" type="primary" style="background-color: #004499; border-color: #004499"
                      :disabled="statisticsDisabled">Statistics Data
            </el-button>
            <el-button @click="showData" type="primary" style="background-color: #004499; border-color: #004499"
                      :disabled="dataDisabled">View Data
            </el-button>
            <el-button v-on:click="downloadData" type="primary" style="background-color: #004499; border-color: #004499"
                      :disabled="downloadDisabled">Download Data
            </el-button>
          </div>
          <div style="margin-top: 1%" align="center">
            <div :hidden="switchHidden">
              <el-switch
                active-color="#13ce66"
                inactive-color="#696969"
                active-text="Logarithmic"
                v-model="switchValue1"
                :disabled="switchHidden1"
                @change="changeChartType"
              >
              </el-switch>
              <el-switch
                active-color="#13ce66"
                inactive-color="#696969"
                active-text="Beam Current"
                v-model="switchValue2"
                :disabled="switchHidden2"
                @change="addBeamCurrSeries">
              </el-switch>
              <el-switch
                active-color="#13ce66"
                inactive-color="#696969"
                active-text="Refetch Data at Zoom"
                v-model="switchValue3"
                :disabled="switchHidden3"
                @change="changeSelectType">
              </el-switch>
            </div>
            <div style="width: 30%; margin-top: 10px" :hidden="progressHidden">
              <!--<font>正在下载第{{downloadSeries}}个PV</font>-->
              <!--<font>downloading data of the {{downloadSeries}}st selected record</font>-->
              <el-progress :text-inside="true" :stroke-width="18" :percentage="percentage">Download Progress</el-progress>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
    <el-dialog title="Data" :visible.sync="dialogTableVisible" width="90%" align="center">
      <div :hidden="dataLoading">
        <i class="el-icon-loading"></i>
      </div>
      <el-row>
        <div align="center">
          <el-table :data="gridData">
            <el-table-column v-for="col in checkedPvList" :property="col" :label="col" :key="col" width="300%"
                             align="center" header-align="center"></el-table-column>
          </el-table>
        </div>
      </el-row>
      <el-row>
        <span class="demonstration" align="center">page select</span>
        <el-pagination
          layout="prev, pager, next,jumper"
          :page-count="pageNumber"
          :current-page.sync="currentPage"
          @current-change="pageChange" align="center">
        </el-pagination>
      </el-row>
    </el-dialog>
    <el-dialog title="Statistics" :visible.sync="statisticsDialogTableVisible" width="90%" align="center">
      <div :hidden="statisticsLoading">
        <i class="el-icon-loading"></i>
      </div>
      <el-table :data="statisticsData" align="center">
        <el-table-column property="Pv_Name" label="Pv Name"></el-table-column>
        <el-table-column property="Mean" label="Mean"></el-table-column>
        <el-table-column property="Deviation" label="Deviation"></el-table-column>
        <el-table-column property="RMS" label="RMS"></el-table-column>
        <el-table-column property="Max" label="Max"></el-table-column>
        <el-table-column property="Min" label="Min"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
    export default {
        name: "pvDrawLine",
        props:{
          pvDetailInfo:{
            type:Object,
            default:{}
          }
        },
        computed:{
          dialogTitle:{
            get:function() {
              return 'Historical Data for  ' + '' + this.pvDetailInfo.pvName
            }
          }
        },
        data(){
          return {
            fullscreen:true,
            isShowDetail:true,
            chartLoading: false,
             //图表属性
            options: {
              // scrollbarEnabled:false,
              chart: {
                width: 1000,
                height: 550,
                // panning: false, //禁用放大
                // pinchType: '', //禁用手势操作
                // zoomType: "",
                // panKey: 'shift',
                zoomType: 'x',
                panKey: 'shift',
                resetZoomButton: {
                  relativeTo: 'chart',
                  animation: false
                },
                // spacingBottom:200,
                plotBorderWidth: 1,
                plotBorderColor: 'grey'
              },
              colors: ['#FF0000', '#434348', '#90ed7d', '#f7a35c', '#8085e9',
                '#f15c80', '#e4d354', '#8085e8', '#8d4653', '#91e8e1'],
              noData: {
                style: {
                  fontWeight: 'bold',
                  fontSize: '15px',
                  color: '#303030'
                }
              },
              plotOptions: {
                series: {
                  turboThreshold: 2000,
                  animation: false
                },
                line: {
                  dataGrouping: {
                    enabled: false
                  }
                }
              },
              title: {
                text: null
              },
              xAxis: {
                gridLineDashStyle: 'ShortDash',
                gridLineWidth: 1,
                ordinal: false,
                title: {
                  text: 'Time',
                  style: {
                    color: "black",
                    fontWeight: 1000
                  }
                },
                type: 'datetime',
                dateTimeLabelFormats: {
                  millisecond: '%H:%M:%S.%L',
                  second: '%H:%M:%S',
                  minute: '%H:%M',
                  hour: '%m-%d %H:%M',
                  day: '%m-%d %H:%M',
                  week: '%m-%d %H:%M',
                  month: '%Y-%m-%d %H:%M',
                  year: '%Y'
                },
                lineColor: 'black',
                step: 4,
                events:{
                  afterSetExtremes:this.afterSetExtremes
                }
              },
              yAxis: [],
              lang: {
                downloadCSV: '下载CSV文件',
                noData: "no data"
              },
              tooltip: {
                dateTimeLabelFormats: {
                  millisecond: '%m-%d %H:%M:%S.%L',
                  second: '%m-%d %H:%M:%S',
                  minute: '%m-%d %H:%M',
                  hour: '%m-%d %H:%M',
                  day: '%Y-%m-%d %H:%M',
                  week: '%m-%d %H:%M',
                  month: '%Y-%m',
                  year: '%Y-%m-%d'
                }
              },
              credits: {
                enabled: false,
              },
              rangeSelector: false,
              navigator: {
                margin: 40
                // enabled:false
              },
              scrollbar: {
                // enabled:false
                // height:0
              },
              legend: {
                enabled: true,
                verticalAlign: 'bottom',
                // layout: 'vertical',
                align: 'middle',
                layout: 'horizontal',
                maxHeight: 40
              },
              series: [],
              exporting:{
                enabled:true,
                buttons:{
                  test:{
                    x:-30,
                    y:2,
                    text:'reset',
                    titleKey:'reset',
                    // symbol:'circle',
                    onclick:this.resetChart,
                    hoverSymbolFill:null,
                    theme:{
                      stroke:'silver',
                      states:{
                        hover:{
                          fill:'#e6e6e6'
                        },
                        select:{
                          stroke:'#039',
                          fill:'#bada55'
                        }
                      }
                    }
                  }
                }
              }
            },
            //进度条
            progressHidden: true,
            percentage: 0,
            //Sample的下拉框
            ppOptions:[{
              value:'First Sample',
              label:'First Sample'
            },{
              value:'Mean',
              label:'Mean'
            },{
              value:'Min',
              label:'Min'
            },{
              value:'Max',
              label:'Max'
            }],
            ppOptionsCopy:[{
              value:'First Sample',
              label:'First Sample'
            },{
              value:'Mean',
              label:'Mean'
            },{
              value:'Min',
              label:'Min'
            },{
              value:'Max',
              label:'Max'
            }],
            //选择的Sample的值
            ppValue:"Max",
            timeMin:null,
            timeMax:null,
            isDisabled:false,
            switchValue1: false,
            switchValue2: false,
            switchValue3: true,
            switchHidden1: false,
            switchHidden2: false,
            switchHidden3: false,
            switchHidden: false,
            pickerOptions: {
              shortcuts: [{
                text: '最近一天',
                onClick(picker) {
                  const end = new Date();
                  const start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24);
                  picker.$emit('pick', [start, end]);
                }
              }, {
                text: '最近一周',
                onClick(picker) {
                  const end = new Date();
                  const start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                  picker.$emit('pick', [start, end]);
                }
              }, {
                text: '最近30天',
                onClick(picker) {
                  const end = new Date();
                  const start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                  picker.$emit('pick', [start, end]);
                }
              }, {
                text: '最近90天',
                onClick(picker) {
                  const end = new Date();
                  const start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                  picker.$emit('pick', [start, end]);
                }
              }]
            },
            value5: [new Date(Date.now() - 3600 * 24 * 1000), new Date(Date.now())],
            //disabled
            queryDisabled: false,
            statisticsDisabled: false,
            dataDisabled: false,
            downloadDisabled: false,
            downloadSeries: 1,
            groups: [{number: 1, pvs: [{name: ''}], logCheck: false}],
            checkedPvList: [],
            dialogTableVisible: false,
            statisticsDialogTableVisible: false,
            statisticsData: [],
            //Loading
            statisticsLoading: true,
            dataLoading: true,
            chartLoading: false,
            showHeader: false,
            gridData: [{pvName: 'RNG:BEAM:CURR'}, {pvName: 'RNG:BEAM:LIFE'}],
            isHidden: false,
            //分页属性
            //使用懒加载，加载一页，显示一页
            pageNumber: 0,
            pageSize: 100,
            currentPage: 1,
            daSourceValue:'HBase',
          } 
        },
      mounted(){
        this.groups[0].pvs[0].name = this.pvDetailInfo.pvName;
        this.getDataSource();
      },
      methods:{
        getDataSource:function(){
          this.$axios({ 
              method:'get',
              url:'/hlsii/hlsii/user/getDataSource'
            }).then((response) => {
              this.daSourceValue = response.data.name;
              this.query();
            }).catch((error) => {
              this.daSourceValue = 'Oracle'
              this.query();
            })
        },
         //draw line chart
        query: function (flag) {
          let _this = this;
          if (this.groups.length == 1 && (this.groups[0].pvs.length === 1 && this.groups[0].pvs[0] == '')) {
            return;
          }
          if(flag == 'select'){
            this.switchValue2 = true;
          }else{
            this.switchValue2 = false;
          }
          let count = 0;
          this.options.yAxis = [];
          this.options.series = [];
          this.checkedPvList = [];
          let date1 = new Date(this.value5[0]);
          let date2 = new Date(this.value5[1]);
          if(this.switchValue3 && this.timeMin && this.timeMax){
            date1 = new Date(this.timeMin);
            date2 = new Date(this.timeMax);
          }
          let time1 = date1.format("yyyy-MM-dd hh:mm:ss");
          let time2 = date2.format("yyyy-MM-dd hh:mm:ss");
          this.queryDisabled = true;
          this.chartLoading = true;
          let pvList = "";
          let checkedPvList = [];
          for (let i = 0; i < this.groups.length; i++) {
            if (this.groups[i].pvs[0].name === '') {
              this.$confirm("请输入需要查询的PV", "提示", {
                showCancelButton: false,
                showConfirmButton: false,
              })
              this.chartLoading = false;
              this.queryDisabled = false;
              return;
            }
          }
          for (let i = 0; i < this.groups.length; i++) {
            let yType = this.groups[i].logCheck ? "logarithmic" : "linear";
            this.options.yAxis.push({
              showFirstLabel: true,
              showLastLabel: true,
              // gridLineDashStyle:'ShortDash',
              gridLineWidth: 0,
              title: {
                text: null,
                style: {
                  color: "black",
                  fontWeight: 1000
                }
              },
              type: yType,
              opposite: false,
              lineWidth: 2
            })
            this.$axios.get(this.urlFragment + '/pvunit/' + this.groups[i].pvs[0].name)
              .then(function (response) {
                if (response.data === null || response.data == "unknown") {
                  _this.options.yAxis[i].title.text = _this.groups[i].pvs[0].name
                } else {
                  _this.options.yAxis[i].title.text = response.data
                }
              })
          }
          for (let i = 0; i < this.groups.length; i++) {
            for (let j = 0; j < this.groups[i].pvs.length; j++) {
              if (this.groups[i].pvs[j].name !== '') {
                pvList = pvList + this.groups[i].pvs[j].name;
                checkedPvList.push(this.groups[i].pvs[j].name);
                count++;
                this.options.series.push({
                  name: _this.groups[i].pvs[j].name,
                  data: null,
                  yAxis: i,
                  type: 'line',
                  lineWidth: 1.5
                })
              }
            }
          }
          let failedPvList = []
          let emptyPvList = []
          if(this.daSourceValue === "Oracle"){
            this.$axios.get(this.urlFragment + "/history/nameMap/" + pvList + "/" + time1 + "/" + time2)
              .then(function (response) {
                _this.options.xAxis.title.text= 'Time';
                if (response.status !== 200) {
                  _this.$confirm("查询失败", "提示", {
                    showCancelButton: false,
                    showConfirmButton: false,
                  })
                  _this.queryDisabled = false;
                  _this.chartLoading = false;
                  return
                }
                if (response.data == null || response.data === "" || response.data.length === 0) {
                  _this.$confirm("查询结果为空", "提示", {
                    showCancelButton: false,
                    showConfirmButton: false,
                  })
                  _this.queryDisabled = false;
                  _this.chartLoading = false;
                  return
                }
                let data = response.data;
                for (let k = 0; k < checkedPvList.length; k++) {
                  let name = checkedPvList[k];
                  let p = [];
                  p.push([date1.getTime(), null])
                  if (data[name][0].float_val != null) {
                    for (let i = 0; i < data[name].length; i++) {
                      p.push([data[name][i].smpl_time, data[name][i].float_val]);
                    }
                  } else {
                    for (let i = 0; i < data[name].length; i++) {
                      p.push([data[name][i].smpl_time, data[name][i].num_val]);
                    }
                  }
                  p.push([date2.getTime(), null]);
                  _this.options.series[k].data = p;
                 
                }
                _this.queryDisabled = false;
                _this.chartLoading = false;
                alertInfo(failedPvList, emptyPvList);
            })
          }else if(this.daSourceValue === "HBase"){
            _this.$axios.get('/hdars/hdars/api/history?pvListStr=' + pvList + '&' + 'type=' + this.ppValue + '&from='+ date1.toISOString() + '&to=' + date2.toISOString())
              .then(function (response1) {
                let sampleDuration = response1.data.data.sampleDuration;
                  let sampleDurationStr = '';
                  if(sampleDuration || sampleDuration==0){
                    if(sampleDuration == 60){
                      sampleDurationStr = 'Sample[1 Minute]';
                    }
                    if(sampleDuration == 3600){
                      sampleDurationStr = 'Sample[1 Hour]';
                    }
                    if(sampleDuration == 86400){
                      sampleDurationStr = 'Sample[1 Day]';
                    }
                    if(sampleDuration == 0){
                      sampleDurationStr = 'Raw';
                    }
                  }
                  _this.options.xAxis.title.text= sampleDurationStr;
                if (response1.data.data.list[0].data.length == 0) {
                  _this.$notify.error({
                    title: '错误',
                    message: pvList  + " 查询结果为空",
                    position: 'top-right',
                    offset: 400,
                    duration: 0
                  });
                  _this.chartLoading = false;
                  if (--count === 0) {
                    _this.queryDisabled = false;
                    _this.chartLoading = false;
                  }
                  return;
                }
                for (let i = 0; i < checkedPvList.length; i++) {
                  let name = checkedPvList[i]
                  if (response1.data.data.list[0].pvName == null || response1.data.data.list.length === 0) {
                    emptyPvList.push(name)
                    continue;
                  }
                  let p = new Array();
                  p.push([date1.getTime(), null]);
                  if (response1.data.data.list[0].data[0].val != null) {
                    for (let k = 0; k < response1.data.data.list[0].data.length; k++) {
                      p.push([response1.data.data.list[0].data[k].millis, parseFloat(response1.data.data.list[0].data[k].val)]);
                    }
                  }
                  p.push([date2.getTime(), null]);
                  _this.options.series[i].data = p;
                }
                _this.queryDisabled = false;
                _this.chartLoading = false;
                alertInfo(failedPvList, emptyPvList);
                return
              }).catch(function (error) {
            });
          }

          function alertInfo(failedPvList, emptyPvList) {
            if (failedPvList.length !== 0) {
              let str = "";
              for (let j = 0; j < failedPvList.length; j++) {
                if (j < 10) {
                  str += failedPvList[j] + "\n";
                  continue
                }
                if (j === 10) {
                  str += '等' + failedPvList.length + '个PV';
                  break;
                }
              }
              _this.$notify.error({
                title: 'error',
                message: '查询' + str + "失败",
                position: 'top-right',
                offset: 400,
                duration: 0
              })
            }
            if (emptyPvList.length !== 0) {
              let str = "";
              for (let j = 0; j < emptyPvList.length; j++) {
                if (j < 10) {
                  str += emptyPvList[j] + "\n";
                  continue
                }
                if (j === 10) {
                  str += '等' + emptyPvList.length + '个PV';
                  break;
                }
              }
              _this.$notify.error({
                title: 'error',
                message: str + "查询结果为空",
                position: 'top-right',
                offset: 400,
                duration: 0
              })
            }
          }
        },
        //图表框选事件
        afterSetExtremes:function(e){
          this.timeMin = e.min;
          this.timeMax = e.max;
          if(this.switchValue2){
            this.query('select');
          }else{
            this.query();
          }
          if(this.switchValue3){
            this.addBeamCurrSeries();
          }
        },
        //关闭弹出框
        close(){
          this.$emit('close');
        },
        showStatistics: function () {
          let count = 0;
          this.statisticsData = []
          this.statisticsLoading = true;
          this.statisticsDialogTableVisible = true;
          let _this = this;
          let checkedPvList = []
          let date1 = new Date(this.value5[0]);
          let date2 = new Date(this.value5[1]);
          if(this.switchValue3 && this.timeMin && this.timeMax){
            date1 = new Date(this.timeMin);
            date2 = new Date(this.timeMax);
          }
          let time1 = date1.format("yyyy-MM-dd hh:mm:ss");
          let time2 = date2.format("yyyy-MM-dd hh:mm:ss");
          let pvList = ""
          let failedPvList = []
          let emptyPvList = []
          for (let i = 0; i < this.groups.length; i++) {
            for (let j = 0; j < this.groups[i].pvs.length; j++) {
              if (this.groups[i].pvs[j].name !== '') {
                count++;
                checkedPvList.push(this.groups[i].pvs[j].name);
                pvList = pvList + this.groups[i].pvs[j].name;
              }
            }
          }
          if (count === 0) {
            this.$confirm("请输入需要查询的PV", "提示", {
              showCancelButton: false,
              showConfirmButton: false,
            })
            this.statisticsLoading = true;
            return;
          }
          for (let i = 0; i < checkedPvList.length; i++) {
            this.statisticsData.push({
              Pv_Name: checkedPvList[i],
              Mean: null,
              Deviation: null,
              RMS: null,
              Max: null,
              Min: null
            })
          }
          if(this.daSourceValue === "Oracle"){
              this.$axios.get(_this.urlFragment + '/history/statisticsMap/' + pvList + '/' + time1 + '/' + time2)
                .then(function (response) {
                  if (response.data == null) {
                    _this.$notify.error({
                      title: '错误',
                      message: 'PV ' + _this.groups[i].pvs[j].name + '统计信息查询结果为空',
                      position: 'top-right',
                      offset: 400
                    });
                    _this.statisticsLoading = true;
                    return;
                  }
                  for (let i = 0; i < checkedPvList.length; i++) {
                    let name = checkedPvList[i];
                    if (response.data[name] === null || response.data[name].length === 0) {
                      emptyPvList.push(name)
                      continue;
                    }

                    _this.statisticsData[i].Mean = response.data[name].Mean.toFixed(6);
                    _this.statisticsData[i].Deviation = response.data[name].Deviation.toFixed(6);
                    _this.statisticsData[i].RMS = response.data[name].RMS.toFixed(6);
                    _this.statisticsData[i].Max = response.data[name].Max.toFixed(6);
                    _this.statisticsData[i].Min = response.data[name].Min.toFixed(6);
                  }
                  _this.statisticsLoading = true
                  alertInfo(failedPvList, emptyPvList);
              })
          }else if(this.daSourceValue === "HBase"){
              this.$axios.get('/hdars/hdars/api/history/statistics/' + pvList + '/' + date1.toISOString() + '/' + date2.toISOString())
              .then(function (response) {
                if (response.status != 200) {
                  failedPvList.push(pvList)
                  if (--count === 0) {
                    if (failedPvList.length !== 0) {
                      let str = "  ";
                      for (let j = 0; j < failedPvList.length; j++) {
                        str += failedPvList[j] + "  ";
                      }
                      _this.$notify.error({
                        title: 'error',
                        message: '查询' + failedPvList + "失败",
                        position: 'top-right',
                        offset: 400,
                        duration: 0
                      })
                    }
                    if (emptyPvList.length !== 0) {
                      for (let j = 0; j < emptyPvList.length; j++) {
                        str += emptyPvList[j] + "  ";
                      }
                      _this.$notify.error({
                        title: 'error',
                        message: emptyPvList + "查询结果为空",
                        position: 'top-right',
                        offset: 400,
                        duration: 0
                      })
                    }
                    _this.statisticsLoading = true
                  }
                  return;
                }
                _this.statisticsData[0].Mean = response.data.data.statistics.mean;
                _this.statisticsData[0].Deviation = response.data.data.statistics.deviation;
                _this.statisticsData[0].RMS = response.data.data.statistics.rms;
                _this.statisticsData[0].Max = response.data.data.statistics.max;
                _this.statisticsData[0].Min = response.data.data.statistics.min;
                
              })
              .catch(function (error) {
                  failedPvList.push(pvList)
                  if (--count === 0) {
                    alertInfo(failedPvList, emptyPvList)
                    _this.statisticsLoading = true;
                  }
                }
              );
          }

          function alertInfo(failedPvList, emptyPvList) {
            if (failedPvList.length !== 0) {
              let str = "";
              for (let j = 0; j < failedPvList.length; j++) {
                if (j < 10) {
                  str += failedPvList[j] + "\n";
                  continue
                }
                if (j === 10) {
                  str += '等' + failedPvList.length + '个PV';
                  break;
                }
              }
              _this.$notify.error({
                title: 'error',
                message: '查询' + str + "失败",
                position: 'top-right',
                offset: 400,
                duration: 0
              })
            }
            if (emptyPvList.length !== 0) {
              let str = "";
              for (let j = 0; j < emptyPvList.length; j++) {
                if (j < 10) {
                  str += emptyPvList[j] + "\n";
                  continue
                }
                if (j === 10) {
                  str += '等' + emptyPvList.length + '个PV';
                  break;
                }
              }
              _this.$notify.error({
                title: 'error',
                message: str + "查询结果为空",
                position: 'top-right',
                offset: 400,
                duration: 0
              })
            }
          }
        },
        showData: function () {
          this.checkedPvList = [];
          this.dialogTableVisible = true;
          this.currentPage = 1;
          this.pageNumber = 1;
          this.gridData = [];
          let row = {}
          let pvList = "";
          let pv = "";
          let count = 0;
          let date1 = new Date(this.value5[0]);
          let date2 = new Date(this.value5[1]);
          let _this = this;
          if(this.switchValue3 && this.timeMin && this.timeMax){
            date1 = new Date(this.timeMin);
            date2 = new Date(this.timeMax);
          }
          let time1 = date1.format("yyyy-MM-dd hh:mm:ss");
          let time2 = date2.format("yyyy-MM-dd hh:mm:ss");
          let checkedPvList = this.checkedPvList;
          for (let i = 0; i < this.groups.length; i++) {
            for (let j = 0; j < this.groups[i].pvs.length; j++) {
              if (this.groups[i].pvs[j] != null && this.groups[i].pvs[j].name != null && this.groups[i].pvs[j].name != "") {
                row[this.groups[i].pvs[j].name] = "";
                this.checkedPvList.push(this.groups[i].pvs[j].name);
                pv = this.groups[i].pvs[j].name;
                pvList = pvList + pv + "@";
              }
            }
          }
          for (let i = 0; i < this.groups.length; i++) {
            for (let j = 0; j < this.groups[i].pvs.length; j++) {
              if (this.groups[i].pvs[j].name !== '') {
                count++;
              }
            }
          }
          if (count !== 0) {
            this.dataLoading = false;
          } else {
            this.$confirm("请选择需要查询的PV", "提示", {
              showCancelButton: false,
              showConfirmButton: false,
            })
            return;
          }
          if(this.daSourceValue === "Oracle"){
            this.$axios.get(_this.urlFragment + "/history/page/count/" + pvList + "/" + time1 + "/" + time2)
              .then(function (response) {
                if (response.data === 0) {
                  this.$notify.error({
                    title: '错误',
                    message: '查询结果为空',
                    position: 'top-right',
                    offset: 400
                  })
                }
                _this.pageNumber = Math.ceil(response.data % _this.pageSize ? response.data / _this.pageSize : response.data / _this.pageSize + 1);
            })
          }else if(this.daSourceValue === "HBase"){
            this.$axios.get('/hdars/hdars/api/history/page/count/' + pvList.replace(/@/g,"") + '/' + this.ppValue + '/'+ date1.toISOString() + '/' + date2.toISOString())
            .then(function (response) {
              _this.pageNumber = Math.ceil(response.data % _this.pageSize ? response.data / _this.pageSize : response.data / _this.pageSize + 1);
            })
            
            for (let i = 0; i < checkedPvList.length; i++) {
              let pv = checkedPvList[i];
              let name = checkedPvList[i];
              let p = new Array();
              let val = 1
              this.$axios.get("/hdars/hdars/api/history/page/" + val + "/" + this.pageSize + "/" + pv + "/" + this.ppValue + '/'+ date1.toISOString() + '/' + date2.toISOString())
                .then(function (response) {
                  if (response.status != 200) {
                    if (--count === 0) {
                      _this.dataLoading = true
                    }
                    return;
                  } else if (response.data[pv] == null || response.data[pv] === "" || response.data[pv].length === 0) {
                    if (--count === 0) {
                      _this.dataLoading = true
                    }
                    return;
                  }
                  if (response.data[pv][0].val !== null) {
                    for (let j = 0; j < response.data[pv].length; j++) {
                      let time = new Date(response.data[pv][j].millis).format("yyyy-MM-dd hh:mm:ss.S");
                      if (Math.abs(response.data[pv][j].val) < 0.1) {
                       
                        _this.gridData[j][checkedPvList[i]] = time.toString() + "\r\n\r\r\r\n" +
                          parseFloat(response.data[pv][j].val).toPrecision(6);
                        
                      } else {
                        _this.gridData[j][checkedPvList[i]] = time.toString() + "\r\n\r\r\r\n" +
                          parseFloat(response.data[pv][j].val).toFixed(6);
                       
                      }
                    }
                  }
                  if (--count === 0) {
                    _this.dataLoading = true;
                  }
              })
            }
          }

          for (let i = 0; i < this.pageSize; i++) {
            this.gridData.push(Object.assign({}, row));
          }
          let val = 1;
          
        },
        downloadData: function () {
          this.downloadDisabled = true;
          this.downloadSeries = true;
          this.checkedPvList = [];
          let date1 = new Date(this.value5[0]);
          let date2 = new Date(this.value5[1]);
          let name = new Date(Date.now()).format("yyyy_MM_dd_hh_mm_ss");
          if(this.switchValue3 && this.timeMin && this.timeMax){
            date1 = new Date(this.timeMin);
            date2 = new Date(this.timeMax);
          }
          let time1 = date1.format("yyyy-MM-dd hh:mm:ss");
          let time2 = date2.format("yyyy-MM-dd hh:mm:ss");
          let pvList = "";
          let checkedPvList = this.checkedPvList;
          let _this = this;
          for (let i = 0; i < this.groups.length; i++) {
            let pv = "";
            for (let j = 0; j < this.groups[i].pvs.length; j++) {
              if (this.groups[i].pvs[j] != null && this.groups[i].pvs[j].name != null && this.groups[i].pvs[j].name != "") {
                this.checkedPvList.push(this.groups[i].pvs[j].name);
                pv = this.groups[i].pvs[j].name;
                pvList = pvList + pv + "@";
              }
            }
          }
          this.downloadDisabled = true;
          if (!(pvList == null || pvList.length == 0)) {
            this.$confirm("正在计算文件大小和下载时间,请勿离开", "提示", {
              showCancelButton: false,
              showConfirmButton: false,
              closeOnClickModal: false,
              closeOnPressEscape: false,
              closeOnHashChange: false
            })
            if(this.daSourceValue === "Oracle"){
                this.$axios.get(_this.urlFragment + '/download/' + pvList + "/" + time1 + "/" + time2)
                  .then(function (response) {
                    _this.$msgbox.close()
                    _this.$confirm("Estimated file size " + (response.data / 30000).toFixed(3) + "M, download time:" + (response.data / 40000).toFixed(2) + "s， continue?", "Tips", {
                      confirmButtonText: 'confirm',
                      cancelButtonText: 'cancel',
                      type: 'warning'
                    }).then(() => {
                      if (!(pvList == null || pvList.length == 0)) {
                        _this.downloadDisabled = true;
                        _this.progressHidden = false
                        _this.$axios.get(_this.urlFragment + '/download/' + time1 + "/" + time2 + "/" + name + "/" + pvList)
                          .then(function (response) {
                            _this.progressHidden = false;
                            let str = window.location.href;
                            window.open('http://' + str.split("/")[2] + '/data/download/media/' + response.data)
                            // window.open('http://' + '222.195.82.88:8081' + '/download/media/'+response.data)
                            _this.progressHidden = true;
                            _this.downloadDisabled = false
                            clearInterval(_this.timer);
                            _this.percentage = 0;
                          });
                        //_this.timer = setInterval(getIntegralData, 1000);

                        function getIntegralData() {
                          _this.$axios.get(_this.urlFragment + '/download/status/' + name)
                            .then(function (response) {
                              _this.downloadSeries = response.data[0]
                              _this.percentage = response.data[1]
                            })
                        }
                      }
                    }).catch(() => {
                      _this.progressHidden = true
                      _this.downloadDisabled = false
                    })
                  })
            }else if(this.daSourceValue === "HBase"){
                this.$axios.get('/hdars/hdars/api/history/downloadInfo2/' + pvList.replace(/@/g,",") + '/'+ date1.toISOString() + '/' + date2.toISOString())
                .then(function (response) {
                    _this.$msgbox.close()
                    _this.$confirm("Estimated file size: " + response.data.data.szie + ", download time:" + response.data.data.time + ", continue?", "Tips", {
                      confirmButtonText: 'confirm',
                      cancelButtonText: 'cancel',
                      type: 'warning'
                    }).then(() => {
                      if (!(pvList == null || pvList.length == 0)) {
                        _this.downloadDisabled = true;
                        _this.progressHidden = false;
                        _this.$notify.info({
                          title: '提示',
                          message: '正在下载中，请勿离开当前页面',
                          position: 'top-right',
                          offset: 400
                        })
                        _this.$axios.get('/hdars/hdars/download/startDownload/' + response.data.data.taskid)
                          .then(function (response) {
                            let str = window.location.href;
                            window.open('http://' + str.split("/")[2] + '/hdars/hdars/download/media/' + response.data)
                            _this.progressHidden = true;
                            _this.downloadDisabled = false
                            clearInterval(_this.timer);
                            _this.percentage = 0;
                          });
                        _this.timer = setInterval(getIntegralData, 1000);

                        function getIntegralData() {
                          _this.$axios.get('/hdars/hdars/download/downloadProgress/' + response.data.data.taskid)
                            .then(function (response) {
                              _this.downloadSeries = response.data[0]
                              _this.percentage = response.data.data.progress;
                            })
                        }
                      }
                    }).catch(() => {
                      _this.progressHidden = true
                      _this.downloadDisabled = false
                    })
                  })
                }
          } else {
            this.$confirm("请输入需要下载的PV", "提示", {
              showCancelButton: false,
              showConfirmButton: false,
            })
          }
        },
        changeChartType: function () {
          if (this.switchValue1 === true) {
          for (let i = 0; i < this.options.yAxis.length; i++) {
            if (this.options.yAxis[this.options.yAxis.length - 1].title.text === "BeamCurrent(mA)"
              && this.options.yAxis[this.options.yAxis.length - 1].opposite === true) {
              continue;
            }
            this.options.yAxis[i].type = 'logarithmic';
          }
        } else if (this.switchValue1 === false) {
          for (let i = 0; i < this.options.yAxis.length; i++) {
            this.options.yAxis[i].type = 'linear';
          }
        }
        },
        changeSelectType:function(){
        if(this.switchValue3 === true){
          this.options.xAxis.events = {
              afterSetExtremes:this.afterSetExtremes
            }
        }else{
          delete this.options.xAxis.events;
        }
        this.resetChart();
      },
        addBeamCurrSeries: function () {
          if (this.switchValue2 === true) {
            if (this.options.series.length < 1) {
              return;
            }
            this.chartLoading = false;
            let p = [];
            let _this = this;
            let date1 = new Date(this.value5[0]);
            let date2 = new Date(this.value5[1]);
            if(this.switchValue3 && this.timeMin && this.timeMax){
              date1 = new Date(this.timeMin);
              date2 = new Date(this.timeMax);
            }
            let time1 = date1.format("yyyy-MM-dd hh:mm:ss");
            let time2 = date2.format("yyyy-MM-dd hh:mm:ss");
            if(this.daSourceValue === "Oracle"){
                this.$axios.get(this.urlFragment + '/history/id/149/' + time1 + '/' + time2)
                .then(function (response) {
                  let n = response.data.length;
                  _this.options.yAxis.push({
                    // gridLineDashStyle:'ShortDash',
                    gridLineWidth: 0,
                    opposite: true,
                    type: 'linear',
                    title: {
                      text: 'BeamCurrent(mA)',
                      style: {
                        color: "black",
                        fontWeight: 4000
                      }
                    },
                    showFirstLabel: true,
                    showLastLabel: true,
                    min: 0,
                    startOnTick: false,
                    // max:380,
                    lineWidth: 2
                  });
                  let yAxisPosition = _this.options.yAxis.length - 1;
                  for (var i = 0; i < n; i++) {
                    p.push([response.data[i].smpl_time, response.data[i].float_val]);
                  }
                  _this.options.series.push({
                    name: 'RNG:BEAM:CURR',
                    data: p,
                    color: "#0055fa",
                    yAxis: yAxisPosition
                  })
                  _this.chartLoading = false;
                })
            }else if(this.daSourceValue === "HBase"){
                this.$axios.get('/hdars/hdars/api/history?pvListStr=' + 'RNG:BEAM:CURR' + '&' + 'type=' + this.ppValue + '&from='+ date1.toISOString() + '&to=' + date2.toISOString())
                .then(function (response) {
                  let n = response.data.data.list[0].data;
                  _this.options.yAxis.push({
                    gridLineDashStyle: 'ShortDash',
                    gridLineWidth: 0,
                    opposite: true,
                    type: 'linear',
                    title: {
                      text: 'BeamCurrent(mA)',
                      style: {
                        color: "black",
                        fontWeight: 4000
                      }
                    },
                    startOnTick: false,
                    lineColor: 'grey',
                    showFirstLabel: true,
                    showLastLabel: true,
                    min: 0,
                    // max:380,
                    lineWidth: 2
                  });
                  for (var i = 0; i < n.length; i++) {
                    p.push([n[i].millis, parseFloat(n[i].val)]);
                  }
                  _this.options.series.push({
                    name: 'RNG:BEAM:CURR',
                    data: p,
                    color: "#0055fa",
                    yAxis: 1,
                    lineWidth: 1.5
                  })
                })
            }
          } else if (this.switchValue2 === false) {
            if (this.options.yAxis[this.options.yAxis.length - 1].title.text === "BeamCurrent(mA)"
              && this.options.yAxis[this.options.yAxis.length - 1].opposite === true) {
              this.options.yAxis.pop();
              this.options.series.pop();
            }
          }
        },
        pageChange: function (val) {
          let count = 0
          this.gridData = []
          this.dataLoading = false;
          let date1 = new Date(this.value5[0]);
          let date2 = new Date(this.value5[1]);
          let _this = this;
          if(this.switchValue3 && this.timeMin && this.timeMax){
            date1 = new Date(this.timeMin);
            date2 = new Date(this.timeMax);
          }
          let time1 = date1.format("yyyy-MM-dd hh:mm:ss");
          let time2 = date2.format("yyyy-MM-dd hh:mm:ss");
          let checkedPvList = this.checkedPvList;
          this.currentPage = val;
          for (let i = 0; i < this.groups.length; i++) {
            for (let j = 0; j < this.groups[i].pvs.length; j++) {
              if (this.groups[i].pvs[j].name !== '') {
                count++;
              }
            }
          }
          let row = {}
          for (let i = 0; i < this.checkedPvList.length; i++) {
            row[this.checkedPvList[i]] = "";
          }
          for (let i = 0; i < this.pageSize; i++) {
            this.gridData.push(Object.assign({}, row));
          }
          for (let i = 0; i < this.checkedPvList.length; i++) {

            if(this.daSourceValue === "Oracle"){
                this.$axios.get(this.urlFragment + '/history/page/' + val + '/' + this.pageSize + '/' + this.checkedPvList[i] + '/' + time1 + '/' + time2)
                .then(function (response) {
                  if (response.data[0].float_val !== null) {
                    for (let j = 0; j < response.data.length; j++) {
                      let time = new Date(response.data[j].smpl_time).format("yyyy-MM-dd hh:mm:ss.S");
                      if (Math.abs(response.data[j].float_val) < 0.1) {
                     
                        _this.gridData[j][checkedPvList[i]] = time.toString() + "\r\n\r\r\r\n" +
                          response.data[j].float_val.toPrecision(6);
                      } else {
                        _this.gridData[j][checkedPvList[i]] = time.toString() + "\r\n\r\r\r\n" +
                          response.data[j].float_val.toFixed(6);
                      }
                    }
                  } else {
                    for (let j = 0; j < response.data.length; j++) {
                      let time = new Date(response.data[j].smpl_time).format("yyyy-MM-dd hh:mm:ss.S");
                      _this.gridData[j][checkedPvList[i]] = time.toString() + "\r\n\r\r\r\n" +
                        response.data[j].num_val.toPrecision(6);
                    }
                  }
                  if (--count === 0) {
                    _this.dataLoading = true;
                  }
                })
            }else if(this.daSourceValue === "HBase"){
                let pv = this.checkedPvList[0];
                this.$axios.get("/hdars/hdars/api/history/page/" + val + "/" + this.pageSize + "/" + pv + "/" + this.ppValue + '/'+ date1.toISOString() + '/' + date2.toISOString())
                .then(function (response) {
                  if (response.data[pv][0].val !== null) {
                    for (let j = 0; j < response.data[pv].length; j++) {
                      let time = new Date(response.data[pv][j].millis).format("yyyy-MM-dd hh:mm:ss.S");
                      if (Math.abs(response.data[pv][j].val) < 0.1) {
                      
                        _this.gridData[j][checkedPvList[i]] = time.toString() + "\r\n\r\r\r\n" +
                          parseFloat(response.data[pv][j].val).toPrecision(6);
                     
                      } else {
                        _this.gridData[j][checkedPvList[i]] = time.toString() + "\r\n\r\r\r\n" +
                          parseFloat(response.data[pv][j].val).toFixed(6);
                       
                      }
                    }
                  }
                  if (--count === 0) {
                    _this.dataLoading = true;
                  }
                })
            }
          }
        },
        resetChart:function(){
          this.timeMin = null;
          this.timeMax = null;
          this.query();
        }
      }
    }

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/page/activePublic/pvManagement/pvDrawline.vue